import { FocusMonitor } from '@angular/cdk/a11y';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, forwardRef, Input } from "@angular/core";
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material/form-field';
import { SearchResponse, SearchRequest, Sample, SampleService, SampleType, SampleSearchRequest, FilterBuilder } from '@core/data';
import { Observable } from 'rxjs';
import { AUTOCOMPETE_CHIPS_STYLES, ModelAutocompleteChipsComponent } from './model-autocomplete-chips-component';



@Component({
    selector: 'pv-sample-autocomplete-chips',
    templateUrl: './sample-autocomplete-chips.component.html',
    styleUrls: ['./model-autocomplete.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SampleAutocompleteChipsComponent),
            multi: true
        },
        {
            provide: MatFormFieldControl,
            useExisting: SampleAutocompleteChipsComponent
        }
    ],
    styles: [AUTOCOMPETE_CHIPS_STYLES]
})
export class SampleAutocompleteChipsComponent extends ModelAutocompleteChipsComponent<Sample>
{
    @Input()
    sampleType: SampleType;

    constructor(
        protected fm: FocusMonitor,
        protected elRef: ElementRef<HTMLElement>,
        protected _changeDetect: ChangeDetectorRef,
        private _sampleService: SampleService
    ){
        super(fm, elRef, _changeDetect);
    }


    search(search: SearchRequest): Observable<SearchResponse<Sample>> {
        let query: SampleSearchRequest = {ownerOrgKey: search.ownerOrgKey, text: search.text, limit: 10};
        if (this.sampleType) {
            query.sampleType = this.sampleType;
        }

        return this._sampleService.search(query);
    }


}